import React from 'react';
import {
  TextField,
  FormField,
  formFieldRequiredLabel as requiredLabel,
  PasswordField,
} from '@elementary/common-ui/components';
import { useFormContext } from 'react-hook-form';
import SshTunnelFormSection from './SshTunnelFormSection';
import { validatePort } from './utils';

const PostgresFormContent = ({ disabled }: { disabled?: boolean }) => {
  const methods = useFormContext();
  const {
    register,
    formState: { errors, dirtyFields },
  } = methods;

  return (
    <>
      <FormField
        title="Host"
        errorMessage={errors.postgresHost?.message as string}
      >
        <TextField
          {...register('postgresHost', {
            required: requiredLabel,
          })}
          variant="outlined"
          placeholder="e.g. hostname.us-west-2.rds.amazonaws.com"
          disabled={disabled}
          size="large"
        />
      </FormField>
      <FormField
        title="Port"
        errorMessage={errors.postgresPort?.message as string}
      >
        <TextField
          {...register('postgresPort', {
            required: requiredLabel,
            validate: validatePort,
          })}
          variant="outlined"
          placeholder="5432"
          defaultValue="5432"
          disabled={disabled}
          size="large"
        />
      </FormField>
      <FormField
        title="User"
        errorMessage={errors.postgresUser?.message as string}
      >
        <TextField
          {...register('postgresUser', {
            required: requiredLabel,
          })}
          variant="outlined"
          placeholder="e.g. elementary_user"
          disabled={disabled}
          size="large"
        />
      </FormField>
      <FormField
        title="Password"
        errorMessage={errors.postgresPassword?.message as string}
      >
        <PasswordField
          {...register('postgresPassword', {
            required: requiredLabel,
          })}
          isFormValueDirty={dirtyFields.postgresPassword}
          clearFormValue={() => methods.setValue('postgresPassword', '')}
          placeholder="Password"
          disabled={disabled}
          size="large"
        />
      </FormField>
      <SshTunnelFormSection disabled={disabled} />
    </>
  );
};

export default PostgresFormContent;
